import { Box, Collapse, Divider, Flex, Heading, useDisclosure } from '@chakra-ui/react'
import React from 'react'
import { FaAngleDown, FaAngleUp } from 'react-icons/fa'

const Card = ({
  title,
  rightElement,
  hasBorder = true,
  canCollapse = false,
  defaultIsOpen = false,
  children,
  width = '100%',
}) => {
  const { isOpen, onToggle } = useDisclosure({ defaultIsOpen: defaultIsOpen })
  return (
    <Box
      borderWidth={hasBorder ? '1px' : '0'}
      rounded="lg"
      shadow={hasBorder ? '1px 1px 3px rgba(0,0,0,0.3)' : ''}
      width={width}
      p={3}
      h="100%"
      bg="white"
    >
      <Flex justifyContent="space-between" py="2">
        <Flex onClick={onToggle} _hover={{ cursor: 'pointer' }} alignItems={'center'} gap={2}>
          <Heading size="md">{title}</Heading>
          {canCollapse && (isOpen ? <FaAngleUp /> : <FaAngleDown />)}
        </Flex>
        {rightElement}
      </Flex>
      <Divider />

      <Collapse in={!canCollapse || isOpen} animateOpacity overflow="visible">
        <Box mt="4">{children}</Box>
      </Collapse>
    </Box>
  )
}

export default Card
